export default __webpack_public_path__ + "static/media/Yellow0002.31561eaf.png";